export const categoryColorMap: Record<string, { textColor: string; bgColor: string }> = {
    Cardiology: {
        textColor: '#B15427',
        bgColor: '#FEEED6',
    },
    Pulmonology: {
        textColor: '#3A620A',
        bgColor: '#ECFECB',
    },
    Nephrology: {
        textColor: '#2E7C73',
        bgColor: '#E6FAF9',
    },
    Endocrinology: {
        textColor: '#753AAB',
        bgColor: '#ECE6FA',
    },
    'General health': {
        textColor: '#1F5BA8',
        bgColor: '#E7F5FF',
    },
    Oncology: {
        textColor: '#8B1538',
        bgColor: '#FFE6ED',
    },
    Gastroenterology: {
        textColor: '#7C5C00',
        bgColor: '#FFF4D6',
    },
};

export const getCategoryConfig = (category: string) => {
    return (
        categoryColorMap[category] || {
            textColor: '#535862',
            bgColor: '#F5F5F5',
        }
    );
};

export const categories = Object.keys(categoryColorMap).map(cat => ({
    label: cat,
    value: cat,
    ...categoryColorMap[cat],
}));

export const CHART_MARGIN_RATIO = 0.08;
export const CHART_DEFAULT_MARGIN = 1;
export const TIMELINE_CHART_HEIGHT = 300;
export const SEARCH_DEBOUNCE_DELAY = 300;

import { SortOption, TabOption } from '@packages/types';

export const DEFAULT_SORT = SortOption.NAME_ASC;
export const DEFAULT_TAB = TabOption.CLINICAL_MEASURES;

export const DEFAULT_PAGE_SIZE_CALCULATIONS = 20;

export const tabOptions = [TabOption.CLINICAL_MEASURES, TabOption.PATIENT_METRICS];
